import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { ProductInquiryModal } from '../../../../components/custom/modal/product/ProductInquiryModal';
import { useHandleProductInquiry } from '../../../../hooks/product/useHandleProductInquiry';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { IProduct } from '../../../../interfaces/Product.interfaces';

interface RequestConsultButtonProps {
  product: IProduct;
  category: 'PLUVA' | 'PARTNER';
}

export const RequestConsultButton = ({ product, category }: RequestConsultButtonProps) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  const [isProductInquiryModalOpen, setIsProductInquiryModalOpen] = useState<boolean>(false);

  const { handleProductInquiryButtonClick } = useHandleProductInquiry({
    product,
    category,
    page: 'PDP',
  });

  const pvmPhoneNumber = useMemo<string>(() => {
    if (isUserLoggedIn) {
      return '070-4138-2499';
    }

    return '031-607-4997';
  }, [isUserLoggedIn]);

  return (
    <>
      <Button
        onClick={() => {
          handleProductInquiryButtonClick();
          if (!isUserLoggedIn) {
            setIsProductInquiryModalOpen(true);
          }
        }}
      >
        <Tooltip>
          <TooltipText>{'에누리 가능해요 ✨'}</TooltipText>
        </Tooltip>

        <ButtonText>{`가격 상담 ${pvmPhoneNumber}`}</ButtonText>
      </Button>

      {isProductInquiryModalOpen && (
        <ProductInquiryModal product={product} page={'PDP'} onModalClose={() => setIsProductInquiryModalOpen(false)} />
      )}
    </>
  );
};

const Button = styled.button`
  width: 100%;
  max-height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  gap: 4px;

  position: relative;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const ButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const Tooltip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 8px 16px;

  gap: 8px;

  position: absolute;

  top: -44px;
  left: 50%;
  transform: translateX(-50%);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-offblack, #505363);

  overflow: visible;

  &:after {
    border-top: 6px solid #505363;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 0px solid transparent;
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;

    transform: translate(-50%, 0%);
  }
`;

const TooltipText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;
